import React, { useState } from 'react';
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from 'reactstrap';
import { toast } from 'react-toastify';
import Icon from '@mdi/react';
import { mdiDotsVertical } from '@mdi/js';
import { DateUtil, FileUtil } from '../../../../utils';
import DefaultFileImage from '../../../../assets/images/FileType/defaultFile.svg';
import dlIcon from '../../../../assets/icons/dlicon.png';
import eyeIcon from '../../../../assets/icons/eyeicon.png';
import { useTicketDetails } from '../../../../pages/Tickets/context/TicketDetailsProvider';
import { getAuthUser } from '../../../../utils/auth.util';
import { TICKET_STATUS_TYPES } from '../../../../pages/Tickets/TicketDetails/constants';

import './TicketResponse.scss';

export default function TicketResponse({ ticketResponse }) {
  const {
    ticketDetails,
    downloadAttachmentMutation,
    setDisplayModalOpen,
    setDisplayModalFile,
    deleteTicketResponseMutation,
  } = useTicketDetails();
  const [menuOpen, setMenuOpen] = useState(false);
  const toggle = () => setMenuOpen(!menuOpen);

  const handleTicketResponseDownloadAttachment = async (tickResponse, doc) => {
    try {
      const response = await downloadAttachmentMutation.mutateAsync({
        ticketNo: ticketDetails?.TicketNo,
        fileName: doc,
        ticketResponseId: tickResponse?.TicketResponseId,
        type: 'response',
      });
      const blob = new Blob([response], { type: response.type });
      FileUtil.downloadBlobFile(
        blob,
        FileUtil.parseFileName(doc),
        response.type,
      );
    } catch (error) {
      toast.error('Failed to download attachment. Please try again.', {
        className: 'toast-error',
      });
    }
  };

  const handleTicketResponseDisplayAttachment = async (tickResponse, doc) => {
    try {
      const response = await downloadAttachmentMutation.mutateAsync({
        ticketNo: ticketDetails?.TicketNo,
        fileName: doc,
        ticketResponseId: tickResponse?.TicketResponseId,
        type: 'response',
      });
      const blob = new Blob([response], { type: response.type });
      const file = new File([blob], FileUtil.parseFileName(doc), {
        type: response.type,
      });
      setDisplayModalFile(file);
      setDisplayModalOpen(true);
    } catch (error) {
      toast.error('Failed to download attachment. Please try again.', {
        className: 'toast-error',
      });
    }
  };

  const handleDeleteTicketResponse = async ticketResponseId => {
    try {
      await deleteTicketResponseMutation.mutateAsync({
        ticketResponseId,
      });
      toast.success('Ticket response deleted successfully.', {
        className: 'toast-success',
      });
    } catch (error) {
      if (error?.error) {
        toast.error(error?.error, {
          className: 'toast-error',
        });
      } else {
        toast.error('Failed to delete ticket response. Please try again.', {
          className: 'toast-error',
        });
      }
    }
  };

  const ticketResponseOptions = (
    <div className="position-absolute top-0 end-0 m-2">
      <Dropdown isOpen={menuOpen} toggle={toggle}>
        <DropdownToggle
          tag="span"
          className="cursor-pointer"
          data-toggle="dropdown"
          aria-expanded={menuOpen}
        >
          <Icon path={mdiDotsVertical} size={1} />
        </DropdownToggle>
        <DropdownMenu end>
          <DropdownItem
            onClick={() => {
              handleDeleteTicketResponse(ticketResponse?.TicketResponseId);
            }}
          >
            Delete
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );

  return (
    <div className=" comment-body position-relative w-100 p-3 mb-1">
      {ticketResponse?.Requestor === getAuthUser()?.id &&
        ticketDetails?.Status !== TICKET_STATUS_TYPES.CANCELLED &&
        ticketDetails?.Status !== TICKET_STATUS_TYPES.COMPLETED &&
        ticketResponseOptions}
      <div className="comment-sender">{ticketResponse?.RequestorName}</div>
      <p className="comment-text">{ticketResponse?.Comments}</p>
      {ticketResponse?.DocumentNames?.length > 0 && (
        <div className="comment-attachments w-100 d-flex flex-column gap-2 mb-1">
          {ticketResponse?.DocumentNames.map(doc => (
            <div
              key={doc}
              className="ticket-response-document d-flex justify-content-between align-items-center w-100"
            >
              <div className="d-flex flex-row gap-2 align-items-center flex-grow-1">
                <img
                  src={DefaultFileImage}
                  className="ticket-response-document-icon"
                  alt="File Icon"
                />
                <span className="ticket-response-file-name">
                  {FileUtil.parseFileName(doc)}
                </span>
              </div>
              <div>
                <span
                  className="me-2 cursor-pointer"
                  onClick={() =>
                    handleTicketResponseDisplayAttachment(ticketResponse, doc)
                  }
                  title="View File"
                >
                  <img
                    src={eyeIcon}
                    alt="View"
                    className="ticket-response-document-view-download-icon"
                  />
                </span>
                <span
                  className="me-2 cursor-pointer"
                  onClick={() =>
                    handleTicketResponseDownloadAttachment(ticketResponse, doc)
                  }
                  title="Download File"
                >
                  <img
                    src={dlIcon}
                    alt="Download"
                    className="ticket-response-document-view-download-icon"
                  />
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="comment-time">
        {DateUtil.formatElapsedSeconds(ticketResponse?.elaspedTime)}
      </div>
    </div>
  );
}
